// src/app/core/mainPage/mainPagecomp/VideoSection/VideoSection.tsx
import { motion } from "motion/react";
import { useTranslation } from "@/app/core/ui/theme/LanguageProvider";
import type { VideoSectionProps } from "./comp/types";
import { VideoSectionSkeleton } from "./comp/VideoSectionSkeleton";
import { TvCard } from "./comp/TvCard";
import { VideoCard } from "./comp/VideoCard";

export function VideoSection({
  model,
  isLoading = false,
  onModelClick,
}: VideoSectionProps) {
  const { t } = useTranslation();

  if (isLoading) {
    return <VideoSectionSkeleton />;
  }

  const [tvVideo, ...otherVideos] = model.videos;

  const animationProps = {
    initial: { opacity: 0, y: 12 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 0.3 },
  };

  return (
    <motion.section
      {...animationProps}
      className="px-4 py-6 mx-auto max-w-3xl"
    >
      <h2 className="text-xl font-bold text-foreground mb-4 drop-shadow text-center">
        {t('videoModels')}
      </h2>

      {/* Большая карточка */}
      <div className="relative z-10">
        <TvCard
          src={tvVideo}
          name={model.name}
          description={model.description}
          onTry={() => onModelClick(model.id)}
        />
      </div>

      {/* Подложка для трёх карточек */}
      <div className="relative z-0 -mt-6 mx-auto w-[92%] pt-8 pb-1 rounded-3xl bg-white/40 dark:bg-white/10 backdrop-blur-sm border border-white/30 dark:border-white/20 shadow-lg">
        <div className="px-1 flex flex-col gap-2">
          {otherVideos.map((src, idx) => (
            <VideoCard key={idx} src={src} alt={`${model.name} пример ${idx + 2}`} />
          ))}
        </div>
      </div>
    </motion.section>
  );
}